import Icon from '../components/Icon.vue'

Icon.register({
  'universal-access': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 48C371 48 464 141 464 256 464 371 371 464 256 464 141 464 48 371 48 256 48 141 141 48 256 48M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 64C150 64 64 150 64 256S150 448 256 448 448 362 448 256 362 64 256 64zM256 108C275.9 108 292 124.1 292 144S275.9 180 256 180 220 163.9 220 144 236.1 108 256 108zM373.7 206C345 212.8 318.2 218.8 291.6 221.8 292.5 322.9 303.9 344.9 316.6 377.5 320.3 386.7 315.7 397.1 306.4 400.8 297.2 404.4 286.7 399.8 283.1 390.5 274.4 368.2 266 349.9 260.8 312H251.2C246 349.9 237.6 368.2 228.9 390.5 225.3 399.8 214.8 404.4 205.6 400.8 196.3 397.1 191.7 386.7 195.4 377.5 208.1 344.9 219.5 322.9 220.4 221.8 193.8 218.8 167 212.8 138.3 206 129.7 204 124.3 195.4 126.4 186.8S137 172.8 145.6 174.9C242.3 197.7 269.9 197.7 366.4 174.9 375 172.8 383.6 178.2 385.6 186.8 387.7 195.4 382.3 204 373.7 206z'
      }
    ]
  }
})
